export default {
  meta: {
    title: '城市类型配置',
  },
};
